<template>
  <CBreadcrumb v-bind="props">
    <slot></slot>
  </CBreadcrumb>
</template>

<script>
export default {
  props: {
    addClasses: {
      type: [String, Array, Object],
      default: '',
    },
    addLinkClasses: {
      type: [String, Array, Object],
      default: '',
    },
    addLastItemClasses: {
      type: [String, Array, Object],
      default: '',
    },
  },
  computed: {
    items() {
      const routes = this.$route.matched.filter((route) => {
        return route.meta?.label
      })
      return routes.map((route) => {
        const meta = route.meta || {}
        return {
          to: route,
          text: meta.label,
        }
      })
    },
    props() {
      return {
        items: this.items,
        addClasses: this.addClasses,
        addLinkClasses: this.addLinkClasses,
        addLastItemClasses: this.addLastItemClasses,
      }
    },
  },
}
</script>
